import startInDomain from "@ext/markdown/elements/list/edit/models/orderList/logic/startInDomain";
import listCounterReset from "@ext/markdown/elements/list/render/listCounterReset";
import type React from "react";

const OrderList = ({ start, children }: { start?: unknown; children?: React.ReactNode }) => {
	const listStart = startInDomain(start);
	const counterReset = listCounterReset(listStart);
	return (
		<ol start={counterReset && listStart} style={counterReset && { counterReset }}>
			{children}
		</ol>
	);
};

export default OrderList;
